// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-section {
  background: #f8fafc;
}

.terms-header{
    padding-top: 7vh;
}

.terms-title {
  font-size: 40px;
  font-weight: 700;
  color: #0b1c39;
  margin-bottom: 12px;
}

.terms-date {
  font-size: 16px;
  font-weight: 600;
  color: #198754;
  margin-bottom: 12px;
}

.terms-subtitle {
  font-size: 17px;
  line-height: 1.7;
  color: #555;
  max-width: 800px;
  margin: 0 auto;
}

.terms-card {
  background: #ffffff;
  padding: 40px;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.terms-block {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e9ecef;
}

.terms-block:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.terms-block h2 {
  font-size: 28px;
  font-weight: 700;
  color: #0b1c39;
  margin-bottom: 14px;
}

.terms-block p,
.terms-block li {
  font-size: 16px;
  line-height: 1.8;
  color: #444;
}

.terms-block ul {
  padding-left: 22px;
  margin: 0;
}

.support-box strong {
  color: #198754;
}

@media (max-width: 767.98px) {
  .terms-title{
    font-size: 28px!important;
  }

  .terms-block p{
    font-size: 16px!important;
  }

  .terms-card {
    padding: 24px;
    border-radius: 14px;
  }

  .terms-block h2 {
    font-size: 22px;
  }

  .terms-block p,
  .terms-block li,
  .terms-subtitle {
    font-size: 15px!important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/termsandconditions.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,yBAAyB;EAC3B;AACF","sourcesContent":[".terms-section {\n  background: #f8fafc;\n}\n\n.terms-header{\n    padding-top: 7vh;\n}\n\n.terms-title {\n  font-size: 40px;\n  font-weight: 700;\n  color: #0b1c39;\n  margin-bottom: 12px;\n}\n\n.terms-date {\n  font-size: 16px;\n  font-weight: 600;\n  color: #198754;\n  margin-bottom: 12px;\n}\n\n.terms-subtitle {\n  font-size: 17px;\n  line-height: 1.7;\n  color: #555;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.terms-card {\n  background: #ffffff;\n  padding: 40px;\n  border-radius: 18px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n}\n\n.terms-block {\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.terms-block:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.terms-block h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0b1c39;\n  margin-bottom: 14px;\n}\n\n.terms-block p,\n.terms-block li {\n  font-size: 16px;\n  line-height: 1.8;\n  color: #444;\n}\n\n.terms-block ul {\n  padding-left: 22px;\n  margin: 0;\n}\n\n.support-box strong {\n  color: #198754;\n}\n\n@media (max-width: 767.98px) {\n  .terms-title{\n    font-size: 28px!important;\n  }\n\n  .terms-block p{\n    font-size: 16px!important;\n  }\n\n  .terms-card {\n    padding: 24px;\n    border-radius: 14px;\n  }\n\n  .terms-block h2 {\n    font-size: 22px;\n  }\n\n  .terms-block p,\n  .terms-block li,\n  .terms-subtitle {\n    font-size: 15px!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
